var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import gql from "graphql-tag";
import authentication from "@irati/auth";
import Query from "../Query";
import { messageFieldsFragment } from "../../gql/fragments/message";
export var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n query InsMessages($params: InsMessageListParams!) {\n    insMessages(params: $params) {\n      results {\n        ...messageFields\n      }\n      count\n      total\n    }\n  }\n  ", "\n"], ["\n query InsMessages($params: InsMessageListParams!) {\n    insMessages(params: $params) {\n      results {\n        ...messageFields\n      }\n      count\n      total\n    }\n  }\n  ", "\n"])), messageFieldsFragment);
var GetMessagesAnonChat = function (_a) {
    var children = _a.children, roomUuid = _a.roomUuid, tenantProp = _a.tenantUuid, props = __rest(_a, ["children", "roomUuid", "tenantUuid"]);
    var tenantUuid = tenantProp || authentication.userTenant().uuid;
    var variables = { params: { roomUuid: roomUuid, tenantUuid: tenantUuid } };
    return (React.createElement(Query, __assign({ query: query, skip: !roomUuid, variables: variables, useError: false }, props), function (apolloState) { return children(apolloState); }));
};
export default GetMessagesAnonChat;
var templateObject_1;
